import React, { useEffect, useState, useRef } from 'react';
import CloseButton from '@/ctComponents/closeButton';
import SubmitButton from '@/ctComponents/submitButton';
import {
  setAppointmentSSlAndSpec,
  updateInventoryLoadSslSpec,
  SaveApiResMessage,
} from '@/actions';
import { useNotify } from 'react-admin';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import styles from './styles.module.css';
import { useHistory } from 'react-router-dom';

const EditAppointmentModal = ({
  setShow,
  containerName,
  SSLOptions,
  SizeOptions,
  SSL,
  Size,
  editSizeAndSsl,
  setEditSizeAndSsl,
  getContainerDataHandler,
  containerData,
}) => {
  const mounted = useRef(true);
  const history = useHistory();
  const notify = useNotify();
  const sizeSelected = SizeOptions.find((option) => option.value === Size);
  const sslSelected = SSLOptions.find((option) => option.value === SSL);
  const [ssl, setSsl] = useState(sslSelected);
  const [size, setSize] = useState(sizeSelected);
  const [loading, setLoading] = useState('');

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (mounted.current) {
      setSsl(sslSelected);
      setSize(sizeSelected);
    }
  }, [sslSelected, sizeSelected]);

  const handleBookAppointment = () => {
    setLoading(true);
    const updateApi = containerData[0]?.id
      ? updateInventoryLoadSslSpec
      : setAppointmentSSlAndSpec;
    const payload = containerData[0]?.id
      ? {
          container_id: containerData[0]?.id,
          company_id: ssl.value,
          specification_id: size.value,
        }
      : {
          container_string: containerName,
          ssl: ssl.value,
          specification: size.value,
        };
    updateApi(payload)
      .then((res) => {
        if (!mounted.current) return;
        const editSizeAndSSL = !res.data?.container_data?.cabin_is_verified;
        // const editSizeAndSSL = res.new_cabin_id !== queryParams.cabinId;
        // const containerInfo = {
        //   name: containerName,
        // };
        const EdittedqueryParams = new URLSearchParams({
          apiData: JSON.stringify({
            size: size.value,
            ssl: ssl.value,
            containerId: containerData[0]?.id ?? containerName,
            ...(!containerData[0]?.id && { isLiveUnload: true }),
            cabinId: containerData[0]?.id
              ? res.data.container.cabin_id
              : res?.data?.new_cabin_id,
          }),
          ...(containerData[0]?.id && {
            containerData: encodeURIComponent(
              JSON.stringify(res.data.container)
            ),
          }),
          editSizeAndSsl: editSizeAndSSL,
        }).toString();
        const EdittedqueryParamsJson = JSON.parse(
          decodeURIComponent(EdittedqueryParams.split('&')[0].split('=')[1])
        );
        console.log('EdittedqueryParamsJson', EdittedqueryParamsJson);
        if (containerData[0]?.id) {
          history.push(
            `/inventory/emptyAll/appointments?${EdittedqueryParams}`
          );
        } else {
          history.push(`/appointment/container?${EdittedqueryParams}`);
        }
        if (getContainerDataHandler)
          getContainerDataHandler(EdittedqueryParamsJson);
        if (res.message === 'success') {
          if (editSizeAndSsl) {
            setShow(false);
          } else {
            setShow(false);
            if (containerData[0]?.id) {
              history.push(
                `/inventory/emptyAll/appointments?${EdittedqueryParams}`
              );
            } else {
              history.push(`/appointment/container?${EdittedqueryParams}`);
            }
          }
        }
      })
      .catch((err) => {
        if (!mounted.current) return;

        // notify(
        //   typeof err === 'string'
        //     ? err
        //     : 'An error occurred while updating the appointment',
        //   'warning'
        // );

        SaveApiResMessage({
          title: 'Error',
          message:
            typeof err === 'string'
              ? err
              : 'An error occurred while updating the appointment',
          mode: 'warning',
        });
        setShow(false);
        // setLoading(false);
      });
  };

  const onClickeditSizeAndSslLoadContainers = (containerId, updateData) => {
    // notify('Updating container...');
    SaveApiResMessage({
      title: 'Info',
      message: 'Updating container...',
      mode: 'info',
    });

    // Make sure container_id is in the payload
    const payload = {
      ...updateData,
      container_id: containerId,
    };

    return updateInventoryLoadSslSpec(payload)
      .then((res) => {
        // notify('Container updated successfully!');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Container updated successfully!',
          mode: 'success',
        });
        // Refresh the data based on active tab
        // if (activeTab === 'dropped') {
        //   getInventoryList();
        // } else {
        //   getInventoryLoadList(true);
        // }
      })
      .catch((err) => {
        // notify(err?.message || 'Failed to update container', 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err?.message || 'Failed to update container',
          mode: 'warning',
        });
      });
  };
  return (
    <div className={styles.EditAppointmentModalContainer}>
      <span>
        To access editing in this section, first choose the size and SSL for
        container
        <span className={styles.containername}>{containerName}</span>.
      </span>
      <div className={styles.rowselect}>
        <CustomSelectEx
          title={'Size'}
          placeholder={size ? size.label : 'Size'}
          value={size}
          onChange={(item) => setSize(item)}
          options={SizeOptions}
          width={'390px'}
          font={true}
          dropdown={true}
        />
        <CustomSelectEx
          title={'SSL'}
          placeholder={ssl ? ssl.label : 'SSL'}
          value={ssl}
          onChange={(item) => setSsl(item)}
          options={SSLOptions}
          width={'390px'}
          font={true}
          dropdown={true}
        />
      </div>
      <div className={styles.buttonsContainer}>
        <CloseButton onClick={() => setShow(false)} text={'Close'} />
        <SubmitButton
          text={'Save & Continue'}
          onClick={handleBookAppointment}
          loading={loading}
          disable={!ssl || !size}
          font={true}
        />
      </div>
    </div>
  );
};

export default EditAppointmentModal;
